import { WidgetGrid, MobileShortcuts, useDashboardStore } from '@/components/dashboard';
import { useTranslation } from 'react-i18next';
import AnnouncementBanner from '@/components/AnnouncementBanner';

export default function DashboardPage() {
  const { t } = useTranslation();
  const setCustomizeOpen = useDashboardStore((s) => s.setCustomizeOpen);

  return (
    <div>
      <AnnouncementBanner />
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-semibold text-gray-900 tracking-tight">{t('dashboard.title')}</h1>
        <button
          onClick={() => setCustomizeOpen(true)}
          className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-2 text-xs font-medium text-gray-600 hover:text-gray-900 hover:border-gray-300 hover:bg-gray-50 transition-all"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
          </svg>
          Customize
        </button>
      </div>
      <MobileShortcuts />
      <WidgetGrid />
    </div>
  );
}
